export enum SortByType {
  None = 0,
  Popularity = 1,
  Location = 2,
}
